import React from 'react';
import ReactDOM from 'react-dom/client';

import Options from './Options';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    {/* <Provider store={store}> */}
    <Options />
    {/* </Provider> */}
  </React.StrictMode>
);
